import "./NursingCareProviderInJerusalemWithinFiveHours.module.css";
import Header from "@/reusable_sections/Header";
import PatioDoorGlassRepairMontreal from "./sections/PatioDoorGlassRepairMontreal";
import LocationsAndPavilionsInJerusalem from "./sections/LocationsAndPavilionsInJerusalem";
import ServicesGrid from "./sections/ServicesGrid";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import BookYourCandiacService from "./sections/BookYourCandiacService";
import Footer from "@/reusable_sections/Footer";
export default function NursingCareProviderInJerusalemWithinFiveHoursPage() {
  return <div>
      <Header />
      <PatioDoorGlassRepairMontreal />
      <LocationsAndPavilionsInJerusalem />
      <ServicesGrid />
      <FrequentlyAskedQuestions />
      <BookYourCandiacService />
      <Footer />
    </div>;
}